import Vue from 'vue';
import VueRouter from 'vue-router';

// ---- ROOT ----

import Routes from '../Routes.vue';

// ---- CONTAINERS ----

import App from '../App.vue';
import Admin from '../pages/Admin.vue';

// ---- COMPONENTS ----

import Home from '../pages/Home.vue';

// ---- CATALOG ----

import CatalogAlmacenamiento from '../pages/Catalog/Almacenamiento.vue';
import CatalogSillas from '../pages/Catalog/Sillas.vue';
import CatalogMesas from '../pages/Catalog/Mesas.vue';
import CatalogSalas from '../pages/Catalog/Sofas.vue';
import CatalogLamparas from '../pages/Catalog/Lamparas.vue';
import CatalogAccesorios from '../pages/Catalog/Accesorios.vue';
import CatalogNovedades from '../pages/Catalog/Novedades.vue';
import CatalogEspeciales from '../pages/Catalog/Especiales.vue';

// ---- SELECTIONS ----

import Selections from '../pages/Selections.vue';

import SearchResults from '../pages/Search-result.vue';
import ProductDetail from '../pages/Product-detail.vue';
import Register from '../pages/Register.vue';
import RegisterConfirm from '../pages/Register-confirm.vue';
import Login from '../pages/Login.vue';
import Forgot from '../pages/Forgot-password.vue';
import Recover from '../pages/Recover-password.vue';
import ResetComplete from '../pages/Reset-complete.vue';
import Welcome from '../pages/User/Welcome.vue';
import Config from '../pages/User/Config.vue';
import ConfigPwd from '../pages/User/Config-password.vue';
import PreviousPurchases from '../pages/User/Previous-purchases.vue';
import RequestInvoice from '../pages/User/Request-invoice.vue';
import Favourites from '../pages/User/Favorites.vue';
import ShoppingCart from '../pages/Shopping-cart.vue';
import ShoppingCartConfirm from '../pages/Shopping-cart-confirm.vue';
import ShoppingCartError from '../components/Shopping-cart/Shopping-cart-error.vue';
import ShoppingCartCanceled from '../components/Shopping-cart/Shopping-cart-canceled.vue';
import ShoppingCartBancomer from '../components/Shopping-cart/Shopping-cart-bancomer.vue';
import FAQ from '../pages/Faq.vue';
import Terms from '../pages/Terms.vue';
import About from '../pages/About.vue';
import DeliverSystem from '../pages/Deliver-system.vue';
import ProjectsContract from '../pages/Projects-contract.vue';
import ProjectsContractInterior from '../pages/Projects-contract-interior.vue';
import Privacy from '../pages/Privacy.vue';
import Contact from '../pages/Contact.vue';
import Address from '../pages/User/Address.vue';
import AdminLogin from '../pages/Admin/Admin-login.vue';
import AdminUsers from '../pages/Admin/Admin-users.vue';
import AdminUsersForm from '../pages/Admin/Admin-users-form.vue';

// ---- ADMIN PRODUCTS ----

import AdminProd from '../pages/Admin/Admin-products.vue';
import AdminProdNew from '../pages/Admin/Admin-products-new.vue';
import AdminProdEdit from '../pages/Admin/Admin-products-edit.vue';
import AdminOrders from '../pages/Admin/Admin-order.vue';
import AdminSlider from '../pages/Admin/Admin-slider.vue';
import AdminSliderNew from '../pages/Admin/Admin-slider-new.vue';
import AdminProjects from '../pages/Admin/Admin-projects.vue';
import AdminProjectsNew from '../pages/Admin/Admin-projects-new.vue';
import AdminNewsletter from '../pages/Admin/Admin-newsletter.vue';
import AdminCodigo from '../pages/Admin/Admin-codes.vue';
import AdminCodigoNuevo from '../pages/Admin/Admin-codes-new.vue';
import VerifyAccount from '../pages/Verify-account.vue';
import AccountValid from '../pages/Account-valid.vue';
import NotFound from '../pages/404.vue';

// ---- INJECT VUE ROUTER ----

Vue.use(VueRouter);

// ---- ROUTER INSTANCE ----

export const router = new VueRouter({
	hashbang: false,
	history: true
});

// ---- HTML5 MODE ----

router.mode = 'html5';

// ---- MAP ROUTES ----

router.map({
	// ---- ROOT ----
	
	'/': {
		component: App,
		name: 'app',
		
		// ---- MAIN SUBROUTES ----
		
		subRoutes: {
			'/home': {
				component: Home,
				name: 'home'
			},
			
			// ---- CATALOG ----
			
			'/almacenamiento':{
				component: CatalogAlmacenamiento,
				name: 'almacenamiento'
			},
			'/sillas': {
				component: CatalogSillas,
				name: 'sillas'
			},
			'/mesas': {
				component: CatalogMesas,
				name: 'mesas'
			},
			'/salas': {
				component: CatalogSalas,
				name: 'salas'
			},
			'/lamparas': {
				component: CatalogLamparas,
				name: 'lamparas'
			},
			'/accesorios': {
				component: CatalogAccesorios,
				name: 'accesorios'
			},
			'/novedades': {
				component: CatalogNovedades,
				name: 'novedades'
			},
			'/especiales': {
				component: CatalogEspeciales,
				name: 'especiales'
			},
			
			// ---- END CATALOG ----
			
			'/product/:id': {
				component: ProductDetail,
				name: 'product_detail'
			},
			'/registro':{
				component: Register,
				name: 'register'
			},
			'/confirmacion-registro':{
				component: RegisterConfirm,
				name: 'confirm_register'
			},
			'/usuario/verificar-cuenta/:token': {
				component: VerifyAccount,
				name: 'verify_account'
			},
			'/cuenta-verificada': {
				component: AccountValid,
				name: 'valid_account'
			},
			'/login':{
				component: Login,
				name: 'login'
			},
			'/olvido-contrasena':{
				component: Forgot,
				name: 'forgot_pass'
			},
			'/usuario/reiniciar-contrasena/:token':{
				component: Recover,
				name: 'recover_pass'
			},
			'/contrasena-reiniciada': {
				component: ResetComplete,
				name: 'reset_complete'
			},
			'/bienvenido': {
				component: Welcome,
				name: 'welcome',
				basic_auth: true
			},
			'/configuracion':{
				component: Config,
				name: 'config',
				basic_auth: true
			},
			'/cambiar-contrasena':{
				component: ConfigPwd,
				name: 'config_password',
				basic_auth: true
			},
			'/carrito-de-compra': {
				component: ShoppingCart,
				name: 'shopping_cart'
			},

			// ---- SHOPPING CART ----
			
			'/payment/cash': {
				component: ShoppingCartConfirm,
				name: 'cash'
			},
			'/payment/deposit': {
				component: ShoppingCartConfirm,
				name: 'deposit'
			},
			'/payment/paypal/approved': {
				component: ShoppingCartConfirm,
				name: 'paypal_approved'
			},
			'/payment/paypal/pending': {
				component: ShoppingCartConfirm,
				name: 'paypal_confirm'
			},
			'/payment/paypal/canceled': {
				component: ShoppingCartCanceled,
				name: 'paypal_canceled'
			},
			'/payment/paypal/fail': {
				component: ShoppingCartError,
				name: 'paypal_fail'
			},
			'/bancomer/approved': {
				component: ShoppingCartBancomer,
				name: 'bancomer_approved'
			},
			'/bancomer/canceled': {
				component: ShoppingCartCanceled,
				name: 'bancomer_canceled'
			},
			'/compras-previas': {
				component: PreviousPurchases,
				name: 'previous_purchases'
			},
			'/solicitar-factura/:id': {
				component: RequestInvoice,
				name: 'request_invoice'
			},
			'/favoritos': {
				component: Favourites,
				name: 'favourites'
			},
			'/preguntas-frecuentes': {
				component: FAQ,
				name: 'faq'
			},
			'/terminos-y-condiciones': {
				component: Terms,
				name: 'terms'
			},
			'/acerca': {
				component: About,
				name: 'about'
			},
			'/sistema-envios': {
				component: DeliverSystem,
				name: 'deliver_system'
			},
			'/proyectos-contract': {
				component: ProjectsContract,
				name: 'projects_contract'
			},
			'/proyectos-contract-detalle/:id': {
				component: ProjectsContractInterior,
				name: 'projects_contract_int'
			},
			'/privacidad': {
				component: Privacy,
				name: 'privacy'
			},
			'/contacto': {
				component: Contact,
				name: 'contact'
			},
			'/mis-direcciones': {
				component: Address,
				name: 'address',
				basic_auth: true
			},
			'/resultados': {
				component: SearchResults,
				name: 'search_results'
			},
			'/404': {
				component: NotFound,
				name: 'not_found'
			},

			// ---- SELECTIONS ----

			'/selecciones/:selections': {
				component: Selections,
				name: 'selections'
			}
		},
	},
	
	// ---- ADMIN ROUTES ----

	// '/admin': {
	// 	component: Admin,
	// 	name: 'admin',

	// 	// ---- ADMIN SUBROUTES ----
		
	// 	subRoutes: {
	// 		'/login': {
	// 			component: AdminLogin,
	// 			name: 'admin_login'
	// 		},
	// 		// CRUD users.
	// 		'/users': {
	// 			component: AdminUsers,
	// 			name: 'admin_users',
	// 			admin_auth: true
	// 		},
	// 		'/users/edit/:id': {
	// 			component: AdminUsersForm,
	// 			name: 'admin_users_form',
	// 			admin_auth: true
	// 		},
	// 		// CRUD products.
	// 		'/products': {
	// 			component: AdminProd,
	// 			name: 'admin_products',
	// 			admin_auth: true
	// 		},
	// 		'/products/create': {
	// 			component: AdminProdNew,
	// 			name: 'admin_product_new',
	// 			admin_auth: true
	// 		},
	// 		'products/edit/:id': {
	// 			component: AdminProdEdit,
	// 			name: 'admin_product_edit',
	// 			admin_auth: true
	// 		},
	// 		// CRUD pedidos.
	// 		'/orders':{
	// 			component: AdminOrders,
	// 			name: 'admin_orders',
	// 			admin_auth: true
	// 		},
	// 		// CRUD sliders.
	// 		'/slider':{
	// 			component: AdminSlider,
	// 			name: 'admin_slider',
	// 			admin_auth: true
	// 		},
	// 		'/slider-new':{
	// 			component: AdminSliderNew,
	// 			name: 'admin_slider_new',
	// 			admin_auth: true
	// 		},
	// 		'/projects':{
	// 			component: AdminProjects,
	// 			name: 'admin_projects',
	// 			admin_auth: true
	// 		},
	// 		'/projects-new':{
	// 			component: AdminProjectsNew,
	// 			name: 'admin_projects_new',
	// 			admin_auth: true
	// 		},
	// 		'/newsletter':{
	// 			component: AdminNewsletter,
	// 			name: 'admin_newsletter',
	// 			admin_auth: true
	// 		},
	// 		'/codigos-promo':{
	// 			component: AdminCodigo,
	// 			name: 'admin_code',
	// 			admin_auth: true
	// 		},
	// 		'/codigo-nuevo':{
	// 			component: AdminCodigoNuevo,
	// 			name: 'admin_code_new',
	// 			admin_auth: true
	// 		},
	// 	},
	// },
});

// ---- HANDLERS ----
router.redirect({ '/': '/home' });
// router.redirect({ '/admin': '/admin/login' });
router.redirect({ '*': '/404' });
router.redirect({ '/index.html': '/home' });

router.afterEach(transition => {
	window.scrollTo(0, 0);
});

// ---- AUTHORIZATION ----

router.beforeEach(transition => {
	// Get if the user is logged.
	let user = JSON.parse(localStorage.getItem('lasddi')) || {};
	let send_to_home = ['login', 'register'];

	// Check if the route to needs auth and the user is not logged.
	if (transition.to.basic_auth && !user.token) {
		// Check if browser supports encodeURIComponent.
		if (!encodeURIComponent) {
			alert('Your browser don\' supports [encodeURIComponent]');
		}

		transition.redirect(`/login?redirect=${encodeURIComponent(transition.to.path)}`);
	}

	// console.log(transition.to);
	// Specific rule, maybe solves an issue, instead redirecting from the component.
	if (transition.to.name === 'product_detail' && transition.to.query.modal && !user.token) {
		transition.redirect(`/login?redirect=${encodeURIComponent(transition.to.path.split('?')[0])}`);
	}

	if (user.token && send_to_home.indexOf(transition.to.name) !== -1) {
		transition.redirect('/home');
	}

	// - DEPRECATED -
	// We don't have the admin here, we have it in laravel blade app.
	// if (transition.to.admin_auth && user.user_type != 'admin') {
	// 	transition.abort();
	// }

	// If we don't have problems, send the client to his destiny.
	transition.next();
});

// ---- ROOT ----

router.start(Routes, '#root');


// WEBPACK FOOTER //
// ./src/routes/routes.js